<div class="skeleton-table">
    <div class="skeleton-row" *ngFor="let row of tableRowsArray">
      <div class="skeleton-checkbox"></div>
      <!-- Generate the number of columns dynamically based on the input -->
      <div class="skeleton-data" *ngFor="let col of tableColumnsArray" [ngClass]="colWidthClass"></div>
    </div>
  </div>
  